export const rarityColors = {
    "6": "#ffd700",  // gold
    "5": "#ffd700",  // gold
    "4": "#9c27b0",  // purple
    "3": "#03a9f4",  // blue
  };
  